<template>
    <!-- 안건 73 (2026-05-12): items 0건일 때 wrapper 자체 미노출 (창고 단독 + region 1개 시 hide 가드).
         빈 ref020-subheader 가 padding/border 영역만 차지하는 시각 결함 회피. -->
    <div v-if="items && items.length > 0" class="ref020-subheader">
        <!-- 좌측 — 권한 우선순위 단일 그룹 (결정 15) — 가로 스크롤. tool=true 항목은 제외 (우측 sticky 로 이동) -->
        <div class="ref020-subheader-scroll">
            <template v-for="(item, index) in items">
                <a v-if="!isTool(item)"
                   :key="'left-' + index"
                   :href="item.url"
                   :class="['ref020-subheader-item', item.cssClass, { active: item.active }]"
                   :title="item.name">
                    <img v-if="item.iconType === 'img'" :src="item.icon" :alt="item.name" class="ref020-subheader-icon-img" />
                    <i v-else-if="item.iconType === 'material'" class="material-icons ref020-subheader-icon-mat">{{ item.icon }}</i>
                    <span class="ref020-subheader-name">{{ item.name }}</span>
                </a>
            </template>
        </div>

    </div>
</template>

<script>
// REF-020 Phase 2-B (2026-05-04) — 신규 서브헤더 SSOT Vue 컴포넌트
//
// 결정 14 — 센터 띠 = 고정 헤더 일부, 모든 페이지 공통
// 결정 15 — 권한 우선순위 단일 그룹 (시스템관리자 누적)
//   · 회원사 단독 → 🏠 전체센터 + 활성센터 + 🧮 결제대행 계산기 + 💳 결제관리
//   · 창고 단독 → 본인 권한 region 만
//   · 총괄 → 🛡 총괄관리 + 활성센터
//   · 시스템 + 총괄 → 🖥 시스템관리 + 🛡 총괄관리 + 활성센터
//   · 시스템 단독 → 🖥 시스템관리 만
//   · 비로그인 → 활성센터만 (가이드)
// 결정 17 — 우측 sticky 공지사항 (모든 권한)
// 결정 19 — 폭 초과 시 가로 스크롤 + 우측 sticky 고정
//
// props:
//   items — Array of { name, url, icon, iconType('img'|'material'), cssClass, active }
//           MenuResolve::subHeader() 의 MenuGroup 출력을 server-side 에서 변환
//
// 결정 22 critical — props 의 url 은 server-side 권한 검증 결과 (회원사 본인 라우팅 ↔ 다른 회원사 404)
export default {
    name: 'app-subheader',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        // hot-fix #20 안건 27 (2026-05-08): 도구·공지사항 헤더 좌상 도구모음으로 이전.
        // hot-fix #11 의 toolItems computed + isTool 메서드 폐기. tool cssClass 항목 자체가 더 이상 서브헤더에 들어오지 않음.
        isTool(item) {
            return item && item.cssClass && /\btool\b/.test(item.cssClass);
        },
    },
};
</script>

<style scoped>
.ref020-subheader {
    display: flex;
    align-items: stretch;
    background: #fafbfc;
    border-bottom: 1px solid #e5e7eb;
    min-height: 2.5rem;
}
.ref020-subheader-scroll {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: thin;
    flex-grow: 1;
    align-items: center;
    gap: 0.25rem;
    padding: 0 0.5rem;
}
.ref020-subheader-item {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.75rem;
    font-size: 1rem;
    color: #374151;
    text-decoration: none;
    white-space: nowrap;
    border-radius: 0.25rem;
}
.ref020-subheader-item:hover {
    background: #f3f4f6;
    color: #111827;
}
.ref020-subheader-item.active {
    background: #2563eb;
    color: #fff;
}
.ref020-subheader-item.special {
    font-weight: 600;
}
/* hot-fix #20 안건 27 (2026-05-08): 도구 (.tool) + 우측 sticky 영역 CSS 폐기 — 헤더 좌상 도구모음으로 이전.
   서브헤더 = 센터 선택 영역으로 의미 단일화. 안건 26 의 도구 디자인 (.tool 보더+그림자) + .ref020-subheader-right + .ref020-subheader-notice 모두 제거. */
.ref020-subheader-icon-img {
    width: 16px;
    height: auto;
}
.ref020-subheader-icon-mat {
    font-size: 1.3333rem; /* 안건 38 (2026-05-08): 16px — 국기(16px) 와 동일 크기로 통일 */
}
.ref020-subheader-name {
    font-size: 1rem;
}
</style>
